var rule = /(http|https):\/\/\S*/;
export default {
    LOGIN_IN (state, data) {
        state.UserToken = data.token;
        state.loginDatas = data;
        state.studentId = data.studentVOList[0].id;
        state.studentName = data.studentVOList[0].student_name;
        state.studentHeadPor = data.studentVOList[0].student_image == null || data.studentVOList[0].student_image == "" || !rule.test(data.studentVOList[0].student_image) ? '../../../static/images/tx.png' : data.studentVOList[0].student_image;
        state.studentsList = data.studentVOList;
    },
    LOGIN_OUT (state) {
        state.UserToken = "";
        state.loginDatas = "";
        state.studentId = "";
        localStorage.removeItem("tokenStudent");
        localStorage.removeItem("loginDatasStudent");
        localStorage.removeItem("studentId");
        localStorage.removeItem("studentName");
        localStorage.removeItem("studentsList");
    },
    SET_studentId (state, data) {
        state.studentId = data;
    },
    SET_studentName (state, data) {
        state.studentName = data;
    },
    SET_studentHeadPor (state, data) {
        state.studentHeadPor = data;
    },
    toggleNavCollapse (state) {
        state.isSidebarNavCollapse = !state.isSidebarNavCollapse;
    },
    setCrumbList (state, list) {
        state.crumbList = list;
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js